var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "filter-swatch-element",
        _vm.disabled(_vm.swatches.value) ? "disabled" : "",
      ],
      attrs: { status: _vm.active(_vm.swatches.value) },
      on: {
        click: function ($event) {
          return _vm.select(_vm.swatches.value)
        },
      },
    },
    [
      _vm._l(_vm.swatches.colors, function (swatch) {
        return [
          _c("div", {
            staticClass: "swatch",
            style: `background-color: #${swatch}`,
          }),
        ]
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swatch--status" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }